export default {
      formTitle: '车主认证审核进度查询',
      infoArray: [],
      resultTemplates:[]
    }